// Import lodash for utility functions
import _ from "lodash";
// Import necessary MUI Components
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
} from "@mui/material";
// Import utility function to format dates or strings
import { checkKnownDateOrString } from "../functions";

// Component to render a table of approver history
export function ApproverHistoryTable({ data, isLoading }) {
  return (
    <Grid
      component={Paper}
      container
      direction="row"
      sx={{
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {/* Table Head Title */}
              <TableCell align="center" colSpan={4}>
                Approver History
              </TableCell>
            </TableRow>
            <TableRow>
              {
                // Check if data is loading
                isLoading ? (
                  <TableCell>Loading</TableCell>
                ) : !!data.length ? (
                  // If data is available
                  Object.keys(data[0]).map((item, index) => {
                    return (
                      <TableCell key={index}>{_.startCase(item)}</TableCell>
                    );
                  })
                ) : (
                  // Show message if no data is present
                  <TableCell>No Data Available</TableCell>
                )
              }
            </TableRow>
          </TableHead>
          {!!data.length && (
            <TableBody>
              {
                // Map through each data item
                data.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      {
                        // Map through each key-value pair of the item
                        Object.entries(item).map(([key, value]) => {
                          // Render a cell for each value
                          return (
                            <TableCell key={key}>
                              {checkKnownDateOrString(key, value)}
                            </TableCell>
                          );
                        })
                      }
                    </TableRow>
                  );
                })
              }
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </Grid>
  );
}
